import { apiGet, apiDelete, apiMultipart, parseApiError } from "../utils";

export const getTeams = async (
  page,
  perPage,
  search = "",
  { sortOrder = "ASC" } = {},
) => {
  const params = { perPage, page, sortOrder };
  if (search) {
    params.search = search;
  }

  const response = await apiGet("/admin/teams", params);
  if (!response.ok) {
    await parseApiError(response);
  }
  const { items, totalCount } = await response.json();
  return { items, totalCount };
};

export const createTeam = async (payload) => {
  const fd = new FormData();
  fd.append("name", payload.name);
  if (payload.shortName) {
    fd.append("shortName", payload.shortName);
  }
  if (payload.file) {
    fd.append("file", payload.file);
  }

  const response = await apiMultipart("/admin/teams", fd, { method: "POST" });
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};

export const updateTeam = async (id, payload) => {
  const fd = new FormData();
  fd.append("name", payload.name);

  if (payload.shortName) {
    fd.append("shortName", payload.shortName);
  }
  if (payload.file) {
    fd.append("file", payload.file);
  } else if (payload.removeLogo) {
    fd.append("removeLogo", "true");
  }

  const response = await apiMultipart(`/admin/teams/${id}`, fd, {
    method: "PUT",
  });
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};

export const deleteTeam = async (id) => {
  const response = await apiDelete(`/admin/teams/${id}`);
  if (response.status === 204) {
    return {};
  }
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};
